import { cn } from '@/lib/utils';
import type { RestaurantWithProduct } from '@/types';

type OrderType = 'DEADLINE_DISCOUNT' | 'RESERVATION_DISCOUNT' | 'REGULAR_ORDER';

interface OrderTypeSelectorProps {
  selectedOrderType: OrderType;
  onOrderTypeChange: (orderType: OrderType) => void;
  restaurants?: RestaurantWithProduct[];
}

const ORDER_TYPES: Array<{ value: OrderType; label: string }> = [
  { value: 'DEADLINE_DISCOUNT', label: '마감할인' },
  { value: 'RESERVATION_DISCOUNT', label: '예약할인' },
  { value: 'REGULAR_ORDER', label: '일반주문' }
];

// 주문 유형별 활성화 여부 판단 함수
function isOrderTypeAvailable(_orderType: OrderType, restaurants?: RestaurantWithProduct[]): boolean {
  // 가게가 없으면 비활성화
  if (!restaurants || restaurants.length === 0) {
    return false;
  }

  // 가게가 하나라도 있으면 모든 탭 활성화
  // (고객이 주문 못하는 시간에도 어떤 가게들이 있는지 확인 가능하도록)
  return true;
}

export function OrderTypeSelector({ selectedOrderType, onOrderTypeChange, restaurants }: OrderTypeSelectorProps) {
  const handleOrderTypeClick = (orderType: OrderType) => {
    const isAvailable = isOrderTypeAvailable(orderType, restaurants);
    if (isAvailable) {
      onOrderTypeChange(orderType);
    }
  };

  return (
    <nav style={{ marginBottom: '16px' }}>
      <div className="flex p-1 bg-transparent border-2 border-[#DEDEDE]" style={{ borderRadius: '16px' }}>
        {ORDER_TYPES.map(({ value, label }) => {
          const isAvailable = isOrderTypeAvailable(value, restaurants);
          const isSelected = selectedOrderType === value;
          
          return (
            <button
              key={value}
              onClick={() => handleOrderTypeClick(value)}
              disabled={!isAvailable}
              className={cn(
                "flex-1 text-[20px] font-black transition-all duration-200 border-none",
                isSelected && isAvailable
                  ? "bg-[#86DB89]"
                  : "bg-transparent",
                !isAvailable && "opacity-50 cursor-not-allowed"
              )}
              style={{ 
                minHeight: '44px',
                borderRadius: '13px',
                color: isSelected && isAvailable ? '#FFFFFF' : !isAvailable ? '#999999' : '#222222',
                fontWeight: '700'
              }}
            >
              {label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}